/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */
import type {
    BatteryCreateRequest,
    BatteryDroneUsageResponse,
    BatteryResponse,
    BatteryUpdateRequest,
    GetBatteriesParams,
    PagedResponseBatteryResponse
} from '../models';

export type getBatteryResponse200 = {
    data: BatteryResponse;
    status: 200;
};

export type getBatteryResponse400 = {
    data: void;
    status: 400;
};

export type getBatteryResponse500 = {
    data: void;
    status: 500;
};

export type getBatteryResponseSuccess = getBatteryResponse200 & {
    headers: Headers;
};

export type getBatteryResponseError = (getBatteryResponse400 | getBatteryResponse500) & {
    headers: Headers;
};

export type getBatteryResponse = getBatteryResponseSuccess | getBatteryResponseError;

export const getGetBatteryUrl = (batteryId: string) => `/api/v1/batteries/${batteryId}`;

export const getBattery = async (
    batteryId: string,
    options?: RequestInit
): Promise<getBatteryResponse> => {
    const res = await fetch(getGetBatteryUrl(batteryId), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getBatteryResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getBatteryResponse;
};

export type updateBatteryResponse200 = {
    data: BatteryResponse;
    status: 200;
};

export type updateBatteryResponse400 = {
    data: void;
    status: 400;
};

export type updateBatteryResponse500 = {
    data: void;
    status: 500;
};

export type updateBatteryResponseSuccess = updateBatteryResponse200 & {
    headers: Headers;
};

export type updateBatteryResponseError = (updateBatteryResponse400 | updateBatteryResponse500) & {
    headers: Headers;
};

export type updateBatteryResponse = updateBatteryResponseSuccess | updateBatteryResponseError;

export const getUpdateBatteryUrl = (batteryId: string) => `/api/v1/batteries/${batteryId}`;

export const updateBattery = async (
    batteryId: string,
    batteryUpdateRequest: BatteryUpdateRequest,
    options?: RequestInit
): Promise<updateBatteryResponse> => {
    const res = await fetch(getUpdateBatteryUrl(batteryId), {
        ...options,
        body: JSON.stringify(batteryUpdateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'PUT'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: updateBatteryResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as updateBatteryResponse;
};

export type getBatteriesResponse200 = {
    data: PagedResponseBatteryResponse;
    status: 200;
};

export type getBatteriesResponse400 = {
    data: void;
    status: 400;
};

export type getBatteriesResponse500 = {
    data: void;
    status: 500;
};

export type getBatteriesResponseSuccess = getBatteriesResponse200 & {
    headers: Headers;
};

export type getBatteriesResponseError = (getBatteriesResponse400 | getBatteriesResponse500) & {
    headers: Headers;
};

export type getBatteriesResponse = getBatteriesResponseSuccess | getBatteriesResponseError;

export const getGetBatteriesUrl = (params?: GetBatteriesParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ['sort'];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach(v => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/api/v1/batteries?${stringifiedParams}`
        : `/api/v1/batteries`;
};

export const getBatteries = async (
    params?: GetBatteriesParams,
    options?: RequestInit
): Promise<getBatteriesResponse> => {
    const res = await fetch(getGetBatteriesUrl(params), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getBatteriesResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getBatteriesResponse;
};

export type createBatteryResponse201 = {
    data: BatteryResponse;
    status: 201;
};

export type createBatteryResponse400 = {
    data: void;
    status: 400;
};

export type createBatteryResponse500 = {
    data: void;
    status: 500;
};

export type createBatteryResponseSuccess = createBatteryResponse201 & {
    headers: Headers;
};

export type createBatteryResponseError = (createBatteryResponse400 | createBatteryResponse500) & {
    headers: Headers;
};

export type createBatteryResponse = createBatteryResponseSuccess | createBatteryResponseError;

export const getCreateBatteryUrl = () => `/api/v1/batteries`;

export const createBattery = async (
    batteryCreateRequest: BatteryCreateRequest,
    options?: RequestInit
): Promise<createBatteryResponse> => {
    const res = await fetch(getCreateBatteryUrl(), {
        ...options,
        body: JSON.stringify(batteryCreateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'POST'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: createBatteryResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as createBatteryResponse;
};

export type getDroneHistoryResponse200 = {
    data: BatteryDroneUsageResponse[];
    status: 200;
};

export type getDroneHistoryResponse400 = {
    data: void;
    status: 400;
};

export type getDroneHistoryResponse500 = {
    data: void;
    status: 500;
};

export type getDroneHistoryResponseSuccess = getDroneHistoryResponse200 & {
    headers: Headers;
};

export type getDroneHistoryResponseError = (
    | getDroneHistoryResponse400
    | getDroneHistoryResponse500
) & {
    headers: Headers;
};

export type getDroneHistoryResponse = getDroneHistoryResponseSuccess | getDroneHistoryResponseError;

export const getGetDroneHistoryUrl = (batteryId: string) =>
    `/api/v1/batteries/${batteryId}/drone-history`;

export const getDroneHistory = async (
    batteryId: string,
    options?: RequestInit
): Promise<getDroneHistoryResponse> => {
    const res = await fetch(getGetDroneHistoryUrl(batteryId), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getDroneHistoryResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getDroneHistoryResponse;
};
